import React from "react";
import { toastErrorr, toastInfo } from "../../../../../../Helper/ToastMessage";

export default function ViewToken(props) {
    const { open, close, rowData, Heading } = props;

    const copyToClipboard = () => {
        if (!rowData) return;

        navigator.clipboard.writeText(rowData)
            .then(() => {
                toastInfo("Copied to clipboard!");
            })
            .catch(() => {
                toastErrorr("Failed to copy text.");
            });
    };

    return (
        <div
            className="img_pop_allign modal show fade"
            style={{
                display: "block",
                backgroundColor: "#00000055",
                overflow: "auto",
                zIndex: 99999,
            }}
            role="dialog"
        >
            <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "60vw" }}>
                <div className="modal-content" id="nested">

                    <div className="modal-header popheding" id="popupheading">
                        <div className="ml-4">
                            <h5>{Heading || ""}</h5>
                        </div>

                        <button
                            type="button"
                            className="btn-close mr-2 pt-1"
                            onClick={close}
                        ></button>
                    </div>

                    <div className="col-12">
                        <div className="col-12 modal-header justify-content-center">
                            <p style={{ wordBreak: "break-all", width: "55vw" }}>
                                {rowData || "-"}
                            </p>
                        </div>

                        {/* Copy Button */}
                        <div className="text-center mb-3 mt-2">
                            <button
                                className="btn btn-primary"
                                onClick={copyToClipboard}
                            >
                                Copy Token
                            </button>
                        </div>

                    </div>

                </div>
            </div>
        </div>
    );
}
